import React, { useEffect, useState } from "react";
import DivisionCmp from "../../../components/cards/DivisionCmp";
import { SectionModel } from "../../../models/components.model";
import { Address, DocumentUrl } from "../../../models/cartable.model";
import DetailInfoComponentThumbnail from "../../../components/detailInfo/detailInfoComponentThumbnail";
import PersonIcon from "@mui/icons-material/Person";
import ModalGuarantorDetail from "../../../components/modals/ModalGuarantorDetail";

interface SchemaInfoModel {
  data?: Address;
  documentList: DocumentUrl[];
  withoutDoc: boolean;
  document?: any;
}
function _GuarantorDocuments({
  data,
  documentList,
  withoutDoc,
  document,
}: SchemaInfoModel) {
  let identity: any[] = [];
  let nationalCardBack = document?.identityDocuments?.filter(
    (x: any) => x.documentType == "GuarantorNationalCardBack"
  );
  if (nationalCardBack.length > 0) {
    identity?.push(nationalCardBack && nationalCardBack[0]);
  }

  let nationalCardFront = document?.identityDocuments?.filter(
    (x: any) => x.documentType == "GuarantorNationalCardFront"
  );
  if (nationalCardFront.length > 0) {
    identity?.push(nationalCardFront && nationalCardFront[0]!);
  }

  if (document?.chequeInfo?.file) {
    identity?.push(document?.chequeInfo?.file);
  }
  if (document?.chequeInfo?.rearFile) {
    identity?.push(document?.chequeInfo?.rearFile);
  }

  const sections: SectionModel[] = [
    { dataKey: "nationalCode", rowCol: 3, title: "کدملی" },
    { dataKey: "shenasnamehNumber", rowCol: 3, title: "شماره شناسنامه" },
    { dataKey: "mobileNumber", rowCol: 3, title: " شماره موبایل" },
    { dataKey: "fatherName", rowCol: 3, title: " نام پدر" },
    { dataKey: "postalCode", rowCol: 3, title: " کدپستی" },
  ];
  return (
    <DetailInfoComponentThumbnail
      sections={sections}
      data={data}
      documentList={identity}
      height={"20vh"}
      addressByInquiry={true}
      showFooter={false}
      showDoc={withoutDoc}
      modal={<ModalGuarantorDetail props={data} />}
      isGuarantor={true}
    />
  );
}

export default function GuarantorDocuments(props: any) {
  let documentUrlList = [] as DocumentUrl[];
  documentUrlList = props.data;
  // const child = (
  //     <>
  //         {/* {props.data?.map((item: any) => { */}
  //         <_GuarantorDocuments
  //             data={props.data}
  //             documentList={props.data}
  //             withoutDoc={props.data.withoutDoc}
  //         />
  //         {/* })} */}
  //     </>
  // );
  // let identity: any[] = [];
  return (
    <>
      {props.data?.map((item: any) => (
        <DivisionCmp
          child={
            <_GuarantorDocuments
              data={item}
              documentList={item}
              withoutDoc={item.withoutDoc}
              document={item}
            />
          }
          title={item.fullName ? item.fullName : "نام ضامن"}
          icon={<PersonIcon />}
        />
      ))}
    </>
  );
}
